import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { Endpoints, CurrencyPackageNewsListItemKeys, CurrencyPackagesResponseKeys, CurrencyPackageItemKeys } from '../Constants';
import RequestHelper from '../RequestHelper';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import buyItem from './buyItem';
import buyItemWithBillingProfile from './buyItemWithBillingProfile';
import TimeStampManager from '../../utils/TimestampManager';
import store from '../../state/store';
import { setActiveConsumables } from '../../state/slices/consumables/consumables';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { fetchGameRooms } from '../../state/query/games/utils';
import ERROR_CODE from '../../utils/errorCodes';

/** @typedef {import('../Constants').CurrencyPackagesResponse} CurrencyPackagesResponse */
/** @typedef {import('../Constants').PackageListInfo} PackageListInfo */

export default {
  /**
   * @returns {Promise<import("../Constants").BillingProfiles>}
   * @throws Response error
   */
  getBillingProfiles: function () {
    var _getBillingProfiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return RequestHelper.apiGet({
              endpoint: Endpoints.GET_BILLING_PROFILES
            });
          case 3:
            response = _context.sent['0'];
            if (response.billingProfiles !== undefined) {
              response.billingProfiles = transformObjectArrayResponse(response.billingProfiles);
            }
            return _context.abrupt("return", response);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
              code: ERROR_CODE.GET_BILLING_PROFILES_ERROR
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    function getBillingProfiles() {
      return _getBillingProfiles.apply(this, arguments);
    }
    return getBillingProfiles;
  }(),
  getAddressForPurchase: function () {
    var _getAddressForPurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return RequestHelper.apiGet({
              endpoint: Endpoints.GET_PURCHASE_ADDRESS
            });
          case 3:
            response = _context2.sent['0'];
            return _context2.abrupt("return", response);
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
              code: ERROR_CODE.GET_ADDRESS_FOR_PURCHASE_ERROR
            });
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    function getAddressForPurchase() {
      return _getAddressForPurchase.apply(this, arguments);
    }
    return getAddressForPurchase;
  }(),
  /**
   * Gets the available currency packages for the user.
   * @async
   * @returns {Promise<import('./Constants').CurrencyPackagesResponse>} The available currency packages for the user.
   * @throws Response error
   */
  getCurrencyPackages: function () {
    var _getCurrencyPackages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var promoValue,
        endpoint,
        params,
        response,
        transformed,
        i,
        packageType,
        packageListInfo,
        eventPayload,
        _i,
        _args3 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            promoValue = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
            if (promoValue) {
              endpoint = "".concat(Endpoints.GET_CURRENCY_PACKAGES).concat(promoValue);
            } else {
              endpoint = Endpoints.GET_CURRENCY_PACKAGES;
            }
            _context3.prev = 2;
            params = {
              endpoint: endpoint,
              logJSON: true
            };
            _context3.next = 6;
            return RequestHelper.apiGet(params, true);
          case 6:
            response = _context3.sent;
            // Remap the response keys
            /** @type {CurrencyPackagesResponse} */
            transformed = transformObjectResponseKeys(response, CurrencyPackagesResponseKeys); // Make news list a real array
            transformed.NEWS_LIST = transformObjectArrayResponse(transformed.NEWS_LIST);

            // Remap the keys to be real names
            for (i = 0; i < transformed.NEWS_LIST.length; i++) {
              transformed.NEWS_LIST[i] = transformObjectResponseKeys(transformed.NEWS_LIST[i], CurrencyPackageNewsListItemKeys);
            }

            // Only need to transform coins
            packageType = 'coins';
            /** @type {PackageListInfo} */
            packageListInfo = transformed.PACKAGE_LIST[packageType]; // Transform objectArray into real array
            packageListInfo.items = transformObjectArrayResponse(packageListInfo.items);
            if (packageListInfo.items.length == 0) {
              eventPayload = {
                description: 'No currency packages returned from server',
                code: 'C01'
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
            }

            // Remap the keys to be real names
            for (_i = 0; _i < packageListInfo.items.length; _i++) {
              packageListInfo.items[_i] = transformObjectResponseKeys(packageListInfo.items[_i], CurrencyPackageItemKeys);
            }
            transformed.PACKAGE_LIST.vip_room_access.items = transformObjectArrayResponse(transformed.PACKAGE_LIST.vip_room_access.items);
            return _context3.abrupt("return", transformed);
          case 19:
            _context3.prev = 19;
            _context3.t0 = _context3["catch"](2);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
              code: ERROR_CODE.GET_CURRENCY_PACKAGES_ERROR
            });
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 19]]);
    }));
    function getCurrencyPackages() {
      return _getCurrencyPackages.apply(this, arguments);
    }
    return getCurrencyPackages;
  }(),
  buyItem: buyItem,
  buyItemWithBillingProfile: buyItemWithBillingProfile,
  removeBillingProfile: function () {
    var _removeBillingProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(pid) {
      var response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return RequestHelper.apiPost({
              endpoint: Endpoints.REMOVE_BILLING_PROFILE,
              body: {
                profile: pid
              }
            }, true);
          case 3:
            response = _context4.sent;
            _context4.next = 9;
            break;
          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              pid: pid,
              error: JSON.stringify(_context4.t0, Object.getOwnPropertyNames(_context4.t0)),
              code: ERROR_CODE.REMOVE_BILLING_PROFILE_ERROR
            });
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 6]]);
    }));
    function removeBillingProfile(_x) {
      return _removeBillingProfile.apply(this, arguments);
    }
    return removeBillingProfile;
  }(),
  finishWebPurchase: function () {
    var _finishWebPurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(args) {
      var response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return RequestHelper.apiPost({
              endpoint: Endpoints.FINISH_WEB_PURCHASE,
              body: args,
              logJSON: true
            });
          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response && response['0'] ? response['0'] : null);
          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context5.t0, Object.getOwnPropertyNames(_context5.t0)),
              code: ERROR_CODE.FINISH_WEB_PURCHASE_ERROR
            });
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 7]]);
    }));
    function finishWebPurchase(_x2) {
      return _finishWebPurchase.apply(this, arguments);
    }
    return finishWebPurchase;
  }(),
  /**
   * Check promo code.
   * @param {String} code Promo code.
   * @param {String} promotype Promotion type. One of ["purchase", "signup", "lobby"]
   * @param {Number} [currencysku] Required if promotype === "purchase", otherwise undefined. The SKU of the currency purchase.
   */
  checkPromoCode: function () {
    var _checkPromoCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(code, promotype, currencysku) {
      var response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return RequestHelper.apiPost({
              endpoint: Endpoints.CHECK_PROMO_CODE,
              body: _objectSpread({
                promocode: code,
                promotype: promotype
              }, function () {
                if (promotype === 'purchase') {
                  return {
                    ci_id: currencysku
                  };
                }
                return {};
              }())
            }, true);
          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);
          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              body: {
                promoCode: code,
                promotype: promotype,
                currencysku: currencysku
              },
              error: JSON.stringify(_context6.t0, Object.getOwnPropertyNames(_context6.t0)),
              code: ERROR_CODE.CHECK_PROMO_CODE_ERROR
            });
          case 10:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 7]]);
    }));
    function checkPromoCode(_x3, _x4, _x5) {
      return _checkPromoCode.apply(this, arguments);
    }
    return checkPromoCode;
  }(),
  /**
   * Purchase with casino dollars.
   * @param {String} ptype Purchase type. One of ["currency", "task", "restore"]
   * @param {Number} currpkgid Currency package ID.
   * @param {Number} saleId Dynamic Sale ID when purchase is made through a Dynamic Triggered Sale.
   */
  purchaseWithCasinoDollars: function () {
    var _purchaseWithCasinoDollars = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(ptype, currpkgid) {
      var saleId,
        messageId,
        active_game_id,
        trigger_id,
        response,
        _args7 = arguments;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            saleId = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 0;
            messageId = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
            active_game_id = _args7.length > 4 ? _args7[4] : undefined;
            trigger_id = _args7.length > 5 ? _args7[5] : undefined;
            _context7.prev = 4;
            _context7.next = 7;
            return RequestHelper.apiPost({
              endpoint: Endpoints.PURCHASE_WITH_CASINO_DOLLARS,
              body: {
                ptype: ptype,
                currpkgid: currpkgid,
                saleId: saleId,
                messageId: messageId,
                active_game_id: active_game_id,
                trigger_id: trigger_id
              }
            }, false);
          case 7:
            response = _context7.sent;
            fetchGameRooms(true);
            return _context7.abrupt("return", response);
          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](4);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              body: {
                ptype: ptype,
                currpkgid: currpkgid,
                saleId: saleId,
                messageId: messageId,
                active_game_id: active_game_id,
                trigger_id: trigger_id
              },
              error: JSON.stringify(_context7.t0, Object.getOwnPropertyNames(_context7.t0)),
              code: ERROR_CODE.PURCHASE_WITH_CASINO_DOLLARS_ERROR
            });
          case 15:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[4, 12]]);
    }));
    function purchaseWithCasinoDollars(_x6, _x7) {
      return _purchaseWithCasinoDollars.apply(this, arguments);
    }
    return purchaseWithCasinoDollars;
  }(),
  /** @typedef {import("../Constants").DTS} DTS */

  DTSCallbackId: -1,
  /**
   * Refresh DTS state in the store.
   * @param {DTS} existingDTS Used for if initApp already had a DTS.
   * @async
   */
  refreshDTS: function () {
    var _refreshDTS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(existingDTS) {
      var _this = this;
      var usingDTS, response, timeToNextCall;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            /** @type {DTS} */
            usingDTS = null;
            if (existingDTS) {
              _context8.next = 9;
              break;
            }
            _context8.next = 5;
            return RequestHelper.apiGet({
              endpoint: Endpoints.GET_DYNAMIC_SALE
            }, true);
          case 5:
            response = _context8.sent;
            usingDTS = response[0];
            _context8.next = 10;
            break;
          case 9:
            usingDTS = existingDTS;
          case 10:
            // Update the store
            // store.dispatch(setDtsState(usingDTS));

            // If we previously registered and we've called this method sooner than the expiry,
            // clear it. Unregister safely handles the call if it's already been removed and no-ops.
            TimeStampManager.unregister(this.DTSCallbackId);
            timeToNextCall = (usingDTS ? usingDTS.timeRemaining : 10 * 60) * 1000; // Call itself when DTS expires
            // If no DTS, check again in 10 minutes
            this.DTSCallbackId = TimeStampManager.register(timeToNextCall, function () {
              return _this.refreshDTS();
            });
            _context8.next = 18;
            break;
          case 15:
            _context8.prev = 15;
            _context8.t0 = _context8["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              existingDTS: existingDTS,
              error: JSON.stringify(_context8.t0, Object.getOwnPropertyNames(_context8.t0)),
              code: ERROR_CODE.REFRESH_DTS_ERROR
            });
          case 18:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this, [[0, 15]]);
    }));
    function refreshDTS(_x8) {
      return _refreshDTS.apply(this, arguments);
    }
    return refreshDTS;
  }(),
  ActiveConsumablesCallbackId: -1,
  refreshActiveConsumables: function () {
    var _refreshActiveConsumables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var activeConsumables;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return RequestHelper.apiGet({
              endpoint: Endpoints.GET_ACTIVE_CONSUMABLES,
              ignoreCache: true
            }, true);
          case 3:
            activeConsumables = _context9.sent;
            // Update the store
            store.dispatch(setActiveConsumables(activeConsumables));

            // Update the store
            _context9.next = 10;
            break;
          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context9.t0, Object.getOwnPropertyNames(_context9.t0)),
              code: ERROR_CODE.REFRESH_ACTIVE_CONSUMABLES_ERROR
            });
          case 10:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[0, 7]]);
    }));
    function refreshActiveConsumables() {
      return _refreshActiveConsumables.apply(this, arguments);
    }
    return refreshActiveConsumables;
  }(),
  claimFreeConsumable: function () {
    var _claimFreeConsumable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(item_id, item_type) {
      var claimResponse;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return RequestHelper.apiPost({
              endpoint: Endpoints.CLAIM_FREE_CONSUMABLE,
              body: {
                item_id: item_id,
                item_type: item_type
              }
            }, true);
          case 3:
            claimResponse = _context10.sent;
            return _context10.abrupt("return", claimResponse);
          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              body: {
                itemId: item_id,
                itemType: item_type
              },
              error: JSON.stringify(_context10.t0, Object.getOwnPropertyNames(_context10.t0)),
              code: ERROR_CODE.CLAIM_FREE_CONSUMABLE_ERROR
            });
          case 10:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[0, 7]]);
    }));
    function claimFreeConsumable(_x9, _x10) {
      return _claimFreeConsumable.apply(this, arguments);
    }
    return claimFreeConsumable;
  }()
};